import { DEFAULT_LOCALE, LOCALE_TO_SUBDOMAIN_MAP } from '../../constants';
import { DISCOVER_FIVERR_COOKIES } from './constants';

/**
 * Checks if should display Discover Fiverr global message.
 * @param {User} options.user The current user.
 * @param {Context} options.context The request context.
 * @param {Locale[]} options.locales A list of supported locales.
 * @param {Object} options.cookies - The parsed cookies object.
 * @return {Boolean}
 */
export const show = ({ user, context, locales = [], cookies }) => {
    const { browserLanguage, locale } = context;

    return !user.id
        && !!browserLanguage
        && browserLanguage !== DEFAULT_LOCALE
        && !cookies[DISCOVER_FIVERR_COOKIES.DISMISS]
        && LOCALE_TO_SUBDOMAIN_MAP[browserLanguage] !== LOCALE_TO_SUBDOMAIN_MAP[locale]
        && locales.map((locale) => locale.iso_code).includes(browserLanguage);
};
